<!-- Botão adicionar -->
<div>
  <button
    type="button"
    (click)="abrirSeletorArquivo()"
    [disabled]="uploading"
    class="inline-flex items-center gap-1.5 rounded-[0.25rem] bg-[#3b5dcc] px-3 py-1.5 text-[13px] font-normal leading-[18px] tracking-[0] text-white hover:bg-[#2e4ea8] transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
    <lucide-icon name="plus" class="h-[0.9rem] w-[0.9rem]"></lucide-icon>
    Anexo
  </button>
  <input
    #fileInput
    type="file"
    [multiple]="multiple"
    [accept]="extensoesAceitas"
    class="hidden"
    (change)="onArquivoSelecionado($event)">
</div>

<!-- Erro -->
<p *ngIf="erroLocal" class="text-[12px] leading-[1.45] text-red-600 dark:text-red-400">
  {{ erroLocal }}
</p>

<!-- Info de extensões e tamanho -->
<p class="text-[12px] my-[16px] leading-[1.45] text-gray-500 dark:text-gray-400">
  Extensões permitidas: {{ extensoesLabel }}<br>
  Tamanho máximo: {{ tamanhoMaximoMb }}MB.
</p>

<!-- Carregando -->
<div *ngIf="carregando" class="flex items-center justify-center py-6 gap-2 text-[13px] text-gray-500 dark:text-gray-400">
  <svg class="animate-spin h-4 w-4 text-blue-500" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle class="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle>
    <path class="opacity-90" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
  </svg>
  <span class="sr-only">Carregando...</span>
  Carregando anexos...
</div>

<!-- Estado vazio -->
<div
  *ngIf="!carregando && anexos.length === 0"
  class="flex flex-col items-center justify-center gap-3 rounded-[0.4rem] border border-dashed border-[#d7dde7] px-4 py-8 text-center dark:border-gray-600">
  <div class="flex h-[2.8rem] w-[2.8rem] items-center justify-center rounded-full bg-orange-50 dark:bg-orange-900/20">
    <lucide-icon name="paperclip" class="h-5 w-5 text-orange-400"></lucide-icon>
  </div>
  <p class="text-[13px] leading-[1.45] text-gray-500 dark:text-gray-400">
    Clique no botão <strong class="font-semibold text-gray-700 dark:text-gray-200">+Anexo</strong> acima para<br>anexar um documento.
  </p>
</div>

<!-- Lista de anexos -->
<div *ngIf="!carregando && anexos.length > 0" class="max-h-[16rem] overflow-y-auto pr-1">
  <div class="flex flex-col gap-2">
    <div
      *ngFor="let anexo of anexos"
      class="flex items-center gap-2 rounded-[0.25rem] border border-[#d7dde7] bg-white px-3 py-2 dark:border-gray-600 dark:bg-gray-800">
      <lucide-icon
        [name]="getIconeAnexo(anexo.nome)"
        class="h-[1rem] w-[1rem] shrink-0 text-gray-400">
      </lucide-icon>
      <span class="flex-1 truncate text-[13px] leading-[18px] text-gray-700 dark:text-gray-200">
        {{ anexo.nome }}
      </span>

      <div
        *ngIf="anexo.uploading; else anexoDownloadAction"
        class="flex h-[1.75rem] w-[1.75rem] shrink-0 items-center justify-center text-blue-500"
        title="Enviando anexo">
        <svg class="animate-spin h-[1.1rem] w-[1.1rem]" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle class="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle>
          <path class="opacity-90" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
        <span class="sr-only">Enviando...</span>
      </div>

      <ng-template #anexoDownloadAction>
        <button
          *ngIf="!anexo.pending"
          type="button"
          (click)="download.emit(anexo)"
          title="Baixar anexo"
          class="shrink-0 rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-700 dark:hover:text-gray-300 transition-colors">
          <lucide-icon name="download" class="h-[1rem] w-[1rem]"></lucide-icon>
        </button>
      </ng-template>

      <button
        type="button"
        (click)="remove.emit(anexo.id)"
        [title]="anexo.uploading ? 'Cancelar envio' : 'Remover anexo'"
        class="shrink-0 rounded p-1 text-gray-400 transition-colors hover:bg-red-50 hover:text-red-500 dark:hover:bg-red-900/20 dark:hover:text-red-400">
        <lucide-icon [name]="anexo.uploading ? 'x' : 'trash-2'" class="h-[1rem] w-[1rem]"></lucide-icon>
      </button>
    </div>
  </div>
</div>
